import { initialState } from './state';

export function setAll(state, all)  {
  Object.assign(state, { all });
}

export function setCountAll(state, countAll)  {
  Object.assign(state, { countAll });
}

export function setRecent(state, recent) {
  Object.assign(state, { recent });
}

export function selectPatient(state, patient) {
  Object.assign(state, { patient });
}

export function setFromDate(state, fromDate) {
  Object.assign(state, { fromDate });
}

export function setToDate(state, toDate) {
  Object.assign(state, { toDate });
}

export function setLimit(state, limit) {
  Object.assign(state, { limit });
}

export function setOffset(state, offset) {
  Object.assign(state, { offset });
}

export function setPageInfo(state, pageInfo) {
  Object.assign(state, { pageInfo });
}

export function setCount(state, count) {
  Object.assign(state, { count });
}

export function setFilters(state, filters) {
  Object.assign(state, { filters });
}

export function reset(state) {
  Object.assign(state, {...initialState() });
}

export function findAndUpdateRecent(state, alert) {
  const recent = state.recent.map((item) => {
    if (item.node && (item.node.id === alert.id)) {
      return Object.assign(item, { node: alert });
    }

    return item;
  });

  Object.assign(state, { recent });
}
